export default __webpack_public_path__ + "static/4-9bb6f299a3834fdab21de1c01c522f0e.png";